import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, Select, Button } from 'antd';
import StyledTable from '../../../../../commons/styles/table';

const ChannelParameter = (props) => {
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4
    }
  };

  const columns = [
    {
      title: '',
      dataIndex: 'SampleName',
      key: 'SampleName'
    },
    {
      title: translation('CH-01'),
      dataIndex: 'CH-01',
      key: 'CH-01'
    },
    {
      title: translation('CH-02'),
      dataIndex: 'CH-02',
      key: 'CH-02'
    },
    {
      title: translation('CH-03'),
      dataIndex: 'CH-03',
      key: 'CH-03'
    },
    {
      title: translation('CH-04'),
      dataIndex: 'CH-04',
      key: 'CH-04'
    },
    {
      title: translation('CH-05'),
      dataIndex: 'CH-05',
      key: 'CH-05'
    },
    {
      title: translation('CH-06'),
      dataIndex: 'CH-06',
      key: 'CH-06'
    },
    {
      title: translation('CH-07'),
      dataIndex: 'CH-07',
      key: 'CH-07'
    },
    {
      title: translation('CH-08'),
      dataIndex: 'CH-08',
      key: 'CH-08'
    },
    {
      title: translation('CH-09'),
      dataIndex: 'CH-09',
      key: 'CH-09'
    },
    {
      title: translation('CH-10'),
      dataIndex: 'CH-10',
      key: 'CH-10'
    }
  ];
  const dataSource = [
    {
      key: '1',
      SampleName: translation('Channel Name'),
      age: 32,
      address: translation('10 Downing Street')
    },
    {
      key: '2',
      SampleName: translation('Digits'),
      age: 42,
      address: translation('10 Downing Street')
    }
  ];

  return (
    <div>
      <Form
        {...formItemLayout}
        layout="horizontal"
        name={translation('HeaderNumber_current')}
        style={{ margin: '19px', padding: '30px' }}
      >
        <Form.Item label={translation('HD')}>
          <Select style={{ width: 220 }}>
            <Select.Option value="01">01</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item {...buttonItemLayout}>
          <div>
            <Button type="primary" style={{ margin: '10px' }}>
              {translation('Ready By KB-30')}
            </Button>
            <Button type="primary" style={{ margin: '10px' }}>
              {translation('Write By KB-30')}
            </Button>
          </div>
        </Form.Item>

        <StyledTable size="small"
          dataSource={dataSource}
          columns={columns}
          pagination={false}
        />
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(ChannelParameter);
